import { api } from "./clientInstance";

export const fetchTactics    = ()              => api("/tactics");
export const createTactic    = (name)          => api("/tactics", { method: "POST",  body: JSON.stringify({ name }) });
export const updateTactic    = (id, tokens)    => api(`/tactics/${id}`, { method: "PATCH", body: JSON.stringify({ tokens }) });
export const deleteTactic    = (id)            => api(`/tactics/${id}`, { method: "DELETE" });
